const otpFormEnabledEvents = [
  '3811452f-267e-411c-a39d-134339c876e2', // Amit: Flex Event (pre-prod)
  'c2697a57-5a67-4c78-acfe-184ce55103c2', // QS event PROD
];

export const showOTPFormIfMagicLinkEnabled = (eventId: string) =>
  otpFormEnabledEvents.includes(eventId);
